export default {
      id: "line-1-usage",
      viewBox: "0 0 330 160",
      url: __webpack_public_path__ + "img/icons.svg#line-1",
      toString: function () {
        return this.url;
      }
    }